module.exports = __webpack_public_path__ + "static/media/procriadoLogo.12e00b09.svg";